import { TFunction } from "react-i18next";
import { Option } from "../models/Option";
import {WebCache} from "../services/WebCache";

interface InputInterface {
    [key: string]: any;
}

export class OptionMapperHelper {
    
    constructor(private t: TFunction) {}

    public buildTransactionSelectOptions = (operationList: Record<string, string>, showCode:boolean = false, isTransactionStateInput:boolean = false): Array<Option> => {
        let values: Array<Option> = [];
        if(isTransactionStateInput) {
            const grouped: Record<string, string[]> = {};
            for (const [key, label] of Object.entries(operationList)) {
                if (!grouped[label]) grouped[label] = [];
                grouped[label].push(key);
            }
            values = Object.entries(grouped).map(([label, states]) => {
                const stateNumbers = states.map(s => s.split("-")[1]);
                return {
                    value: stateNumbers.join("-"),
                    label: showCode ? `${label} (${stateNumbers.join(", ")})` : label
                };
            });
        } else {
                values = Object.entries(operationList).map(([key, value]) => ({
                value: key,
                label: showCode ? `${value} (${key.split("-")[1]})` : value
            }));
        }
        values.push({ value: "", label: this.t("all"), key: "all" } as Option)
        values.sort((a, b) => {
            if (a.value === "") return -1;
            if (b.value === "") return 1;
            return a.label.localeCompare(b.label);
        });

        return values;
    }

    public buildSelectOptionsFromEnum = (operationList: Array<string>, translationPrefix?: string): Array<Option> => {
        return operationList.map(operation => {
            return this.translateOptionValue({ value: operation, label: operation }, translationPrefix);
        });
    }
        
    public translateOptionValue = (option: Option, prefix?: string): Option => {
        return { value: option.value, label: this.t(`${prefix || ''}${option.label}`) };
    }

    public translateOptionValues = (optionList: Array<Option>): Array<Option> => {
        return optionList.map(option => {
            return this.translateOptionValue(option);
        });
    }

    public buildSelectOptionsFromAnArrayWithDifferentInterface(array: InputInterface[], valueKey: string, labelKey: string): Option[] {
        const mappedOptionList: Option[] = array.map((item) => {
            return {
                value: item[valueKey],
                label: item[labelKey].toString()
            };
        });
        return this.translateOptionValues(mappedOptionList);
    }

    static getAllMerchantNumbersOptions(fiscalDocument: string,includeAll:boolean,includeWholesaler:boolean)
    {
        var include=includeAll;
        if(WebCache.getAllWholesalerMerchants(false).filter(x=>x.key!=null?x.key.indexOf(fiscalDocument)>=0:false).length>0)
            include=false;
        return WebCache.getAllMerchantNumbers(include,includeWholesaler).filter(x=>fiscalDocument?.length==0||
            (include&&x.key=="")||
            x.key?.indexOf(fiscalDocument)==0).map(x=>{return {key:x.label=="all"?"":x.label,label:x.label,value:x.label=="all"?"":x.label,disabled:x.disabled}})
    }

    static getAllMerchantNumbersOptionsForMultipleFiscalDocuments(fiscalDocuments: string[], includeAll: boolean, includeWholesaler: boolean,includeOnlyWholesaler:boolean = false) {
        let include = includeAll;
        let allMerchantNumbers: Option[] = [];
        let allOptionAdded = false;
    
        fiscalDocuments.forEach(fiscalDocument => { //iteramos sobre cada documento 
            const merchantNumbers = WebCache.getAllMerchantNumbers(include, includeWholesaler,includeOnlyWholesaler) //obtenemos los merchant numbers
                .filter(x => fiscalDocument.length === 0 || (include && x.key === "") || x.key?.startsWith(fiscalDocument))
                .map(x => ({ key: x.label === "all" ? "" : x.label, label: x.label, value: x.label === "all" ? "" : x.label, disabled: x.disabled }))
            allMerchantNumbers = [...allMerchantNumbers, ...merchantNumbers];
        });
        
        const allMerchantNumbersFinal = allMerchantNumbers.filter(x => { //filtramos para que la opcion Todos aparezca solo una vez
            if (x.label === "all") {
                if (allOptionAdded) {
                    return false;
                } else {
                    allOptionAdded = true;
                    return true;
                }
            }
            return true;
        });

        allMerchantNumbersFinal.sort((a, b) => { //lo ordenamos de menor a mayor sin considerar la opción Todos que queda en una primera opción 
            if (a.label === "all") return -1;
            if (b.label === "all") return 1;
            return a.label.localeCompare(b.label);
        });
        return allMerchantNumbersFinal;
    }
}